<template>
  <div class="admin-shops-requests-shops-new">
    <header-component></header-component>
    <md-layout md-align="center">
      <md-layout md-column md-flex="90">
        <form>
          <md-input-container>
            <label>店名</label>
            <md-input v-model="shop.name"></md-input>
          </md-input-container>
          <md-input-container>
            <label>最寄駅</label>
            <md-input v-model="shop.station"></md-input>
          </md-input-container>
          <md-input-container>
            <label>場所（例：JR新宿駅から徒歩5分）</label>
            <md-input v-model="shop.place"></md-input>
          </md-input-container>
          <md-input-container>
            <label>食べログ・ぐるなびURL</label>
            <md-input v-model="shop.tabelog_or_gurunavi_url"></md-input>
          </md-input-container>
          <md-input-container>
            <label>都道府県（必ず県や都まで入れること）</label>
            <md-input v-model="shop.prefecture"></md-input>
          </md-input-container>
          <md-input-container>
            <label>住所</label>
            <md-input v-model="shop.address"></md-input>
          </md-input-container>
          <md-input-container>
            <label>メモ</label>
            <md-textarea v-model="shop.memo"></md-textarea>
          </md-input-container>
          <md-input-container>
            <label>推薦の言葉</label>
            <md-input v-model="shop.comments[0].content"></md-input>
          </md-input-container>
          <md-checkbox v-model="shop.closed">閉店</md-checkbox>
        </form>
        <md-button class="md-raised submit-button" v-on:click="onSubmit">登録</md-button>
      </md-layout>
    </md-layout>
  </div>
</template>
<script>
import HeaderComponent from '../../../Header.vue'
import router from '../../../../router/index'
import firebaseApp from '../../../../firebaseApp'
import authenticateUser from '../../../../auth'
import moment from 'moment'
const db = firebaseApp.firestore()

let data = {
  shop: {
    closed: false,
    comments: [{content: ''}]
  }
}

export default {
  name: 'admin-shops-requests-shops-new',
  data: function () {
    return data
  },
  components: {
    HeaderComponent
  },
  created () {
    authenticateUser().then((user) => {
      db.doc(`shop_requests/${this.$route.params.id}`).get().then(function (doc) {
        if (doc.exists) {
          data.shop.name = doc.data().name
          data.shop.station = doc.data().station
          data.shop.created_at = doc.data().created_at
          data.shop.comments = [{content: doc.data().comment}]
        } else {
          router.push({name: 'NotFound'})
        }
      })
    })
  },
  methods: {
    onSubmit: function () {
      const now = moment().toDate()
      data.shop.comments[0].created_at = now
      db.collection('shops').add(data.shop).then((docRef) => {
        db.doc(`shop_requests/${this.$route.params.id}`).delete().then(function () {
          data.shop = {closed: false, comments: [{content: ''}]}
          router.push({name: 'AdminShopRequestsIndex'})
        }).catch(function (error) {
          alert(error + 'リクエストの削除に失敗しました。')
        })
      }).catch(function (error) {
        alert(error + '居酒屋の追加に失敗しました。もう一度追加してください。')
      })
    }
  }
}
</script>
<style scoped>
.submit-button {
  width: 10%;
  margin: 30px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/ShopRequests/Shops/New.vue